import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Puff } from 'react-loader-spinner'
import { BiTrash, BiRun } from 'react-icons/bi'
import { getPhysicalGroups, deletePhysicalGroup } from '../../actions/physicalGroup'
import Li from '../../components/Li'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import PhysicalGroupModal from './Modal'
import styles from './styles.module.scss'

const PhysicalGroup = () => {
  const dispatch = useDispatch()
  const { list, loading } = useSelector(state => state.physical_group)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(null)

  useEffect(() => {
    dispatch(getPhysicalGroups())
  }, [dispatch])

  const handleDelete = useCallback((item) => (e) => {
    e.stopPropagation()
    setConfirmation({ id: item.pid, title: item.title })
  }, [])

  const openModal = useCallback((data) => () => {
    setSelectedItem(data || {})
  }, [])

  const closeModal = useCallback(() => {
    setSelectedItem(null)
  }, [])

  const acceptConfirmation = useCallback(async () => {
    if (!confirmation) return
    await dispatch(deletePhysicalGroup(confirmation.id))
    setConfirmation(null)
  }, [dispatch, confirmation])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(null)
  }, [])

  const sortedList = useMemo(() => {
    if (!list) return []
    return [...list].sort((a, b) => a.title?.localeCompare(b.title))
  }, [list])

  const isModalOpen = selectedItem !== null
  const isAddMode = selectedItem && !selectedItem.pid

  const renderEmptyState = () => (
    <div className={styles.emptyState}>
      <BiRun size={64} className={styles.emptyIcon} />
      <p>Нет добавленных физкультурных групп</p>
      <Button onClick={openModal()}>Добавить первую группу</Button>
    </div>
  )

  const renderLoading = () => (
    <div className={styles.loadingState}>
      <Puff
        height={50}
        width={50}
        color="#3689FF"
        ariaLabel="Загрузка..."
      />
      <span>Загрузка физкультурных групп...</span>
    </div>
  )

  const renderList = () => (
    <div className={styles.listContainer}>
      <ul className={styles.list}>
        {sortedList.map((item) => (
          <Li
            key={item.pid}
            onClick={openModal(item)}
            className={styles.listItem}
          >
            <div className={styles.itemContent}>
              <BiRun size={20} className={styles.itemIcon} />
              <span className={styles.itemName}>{item.title}</span>
            </div>
            <button
              type="button"
              className={styles.deleteBtn}
              onClick={handleDelete(item)}
              title="Удалить группу"
              aria-label={`Удалить ${item.title}`}
            >
              <BiTrash size={22} />
            </button>
          </Li>
        ))}
      </ul>
      <div className={styles.actions}>
        <Button onClick={openModal()}>Добавить</Button>
        <span className={styles.counter}>
          Всего: {sortedList.length}
        </span>
      </div>
    </div>
  )

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>Физкультурные группы</h1>
      </header>

      <main className={styles.content}>
        {loading && renderLoading()}
        {!loading && sortedList.length === 0 && renderEmptyState()}
        {!loading && sortedList.length > 0 && renderList()}
      </main>

      <PhysicalGroupModal
        open={isModalOpen}
        onClose={closeModal}
        data={selectedItem}
        addMode={isAddMode}
      />

      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить "${confirmation.title}"?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </div>
  )
}

export default PhysicalGroup
